import React from 'react'
import actions from 'redux/actions'
import { useCallback } from 'sb-hooks'
import { useField } from 'sb-formx'
import { formatPrice } from 'common/helpers'

import { Checkbox } from 'components/_new/forms'
import Text from 'components/_new/typography/Text/Text'
import { Box } from 'components/_new/layout'
import { Price, CircleLoader } from 'components/_new/ui'

import messages from './messages'
import s from './Credits.scss'


type CreditsProps = {
  creditBalance: number
  useCredits: boolean
  isFetching: boolean
  creditValue?: number
}

const Credits: React.FunctionComponent<CreditsProps> = (props) => {
  const { isFetching, creditValue, creditBalance, useCredits } = props

  const checkBoxField = useField('credits', { value: useCredits })

  const handleChange = useCallback((value) => {
    actions.view.paymentPage.toggleUseCredits(value)
  }, [])

  const titleMessage = { ...messages.creditBalance, values: { balance: formatPrice(creditBalance, true) } }

  return (
    <Box mt={16} className={s.credits} id="billCreditsRow">
      <Text message={titleMessage} />
      {
        isFetching ? (
          <CircleLoader />
        ) : (
          <Checkbox
            className={s.creditsCheckbox}
            field={checkBoxField}
            dataTestId="useCredits"
            onChange={handleChange}
          >
            <Price className={s.price} value={creditValue} isCents />
          </Checkbox>
        )
      }
    </Box>
  )
}


export default Credits
